export default __webpack_public_path__ + "static/media/vuesax-linear-message-text-2.bc794160.svg";